import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" style={{
    enableBackground: "new"
  }} id="svg7384" viewBox="0 0 16 16.000036" width="1em" height="1em" {...props}><title id="title8473">{"Gnome Symbolic Icons"}</title><defs id="defs7386" /><g transform="translate(-112,-91.999995)" id="layer10" /><g transform="translate(-112,-27.999995)" id="layer1" /><g transform="translate(-112,-91.999995)" id="layer11" /><g transform="translate(-112,-27.999995)" id="layer7" /><g transform="translate(-112,-27.999995)" id="layer6" /><g transform="translate(-112,-27.999995)" id="layer5" /><g transform="translate(-112,-27.999995)" id="layer9" /><g transform="translate(-112,-27.999995)" id="layer2"><path className="success" d="m 117,35.999995 v 3 2 h 3 v -2 l 3,-3 v 0 z" id="path3856" style={{
        fill: "#33d17a",
        fillOpacity: 1,
        stroke: "none"
      }} /><path id="path3858" d="m 117.46875,28.011719 c -0.49033,0 -0.79607,0.214784 -1.03125,0.455078 C 116.20232,28.707091 116,29.023351 116,29.496094 V 30 h -2 v 14 h 8 v -2 h -6 V 32 h 2 v -1.988281 h 4 V 32 h 2 v 3 h 2 v -5 h -2 v -0.394531 l -0.002,-0.02734 c -0.0239,-0.430603 -0.18,-0.734707 -0.41602,-1.013672 -0.23602,-0.278964 -0.6205,-0.584896 -1.19922,-0.552734 z" style={{
        color: "#bebebe",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        marker: "none",
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /><path id="path3863" d="m 124.95703,36.001953 a 1.0001,1.0001 0 0 0 -0.66406,0.291016 l -3,3 A 1.0001,1.0001 0 0 0 122,41 h 1 1.10352 l -0.95899,1.404297 a 1.0001,1.0001 0 0 0 1.52344,1.279297 l 3.03125,-2.96875 A 1.0001,1.0001 0 0 0 127,39 h -1 -1.13086 l 0.96289,-1.445312 a 1.0001,1.0001 0 0 0 -0.875,-1.552735 z" style={{
        color: "#bebebe",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontSize: "medium",
        lineHeight: "normal",
        fontFamily: "sans-serif",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecoration: "none",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000000",
        letterSpacing: "normal",
        wordSpacing: "normal",
        textTransform: "none",
        writingMode: "lr-tb",
        direction: "ltr",
        textOrientation: "mixed",
        dominantBaseline: "auto",
        baselineShift: "baseline",
        textAnchor: "start",
        whiteSpace: "normal",
        shapePadding: 0,
        clipRule: "nonzero",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        opacity: 1,
        isolation: "auto",
        mixBlendMode: "normal",
        colorInterpolation: "sRGB",
        colorInterpolationFilters: "linearRGB",
        solidColor: "#000000",
        solidOpacity: 1,
        vectorEffect: "none",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeDashoffset: 0,
        strokeOpacity: 1,
        marker: "none",
        colorRendering: "auto",
        imageRendering: "auto",
        shapeRendering: "auto",
        textRendering: "auto",
        enableBackground: "accumulate"
      }} /><path id="rect3865" d="m 127,38.999996 h 1 v 1 h -1 z" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none"
      }} /><path id="rect3867" d="m 121,39.999996 h 1 v 1 h -1 z" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none"
      }} /><path id="rect3869" d="m 125,35.999996 h 1 v 1 h -1 z" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none"
      }} /><path id="rect3871" d="m 122.96899,42.968494 h 1 v 1 h -1 z" style={{
        color: "#bebebe",
        display: "inline",
        overflow: "visible",
        visibility: "visible",
        fill: "#2e3436",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 2,
        marker: "none"
      }} /></g><g transform="translate(-112,-27.999995)" id="layer8" /><g transform="translate(-112,-27.999995)" id="layer3" /><g transform="translate(-112,-27.999995)" id="layer4" /></svg>;
}

export default SvgComponent;